import { Component, Input } from '@angular/core';
import { TipoProduto_E_OperadoraComponent } from 'src/app/api/module/erp/shared/enumerable/tipo-produto.enum';

@Component({
  selector: 'app-cotacao-informacoes',
  templateUrl: './cotacao-informacoes.component.html',
  styleUrls: ['./cotacao-informacoes.component.scss']
})
export class CotacaoInformacoesComponent {

  @Input() tipoProduto: number = 0;

  isOdonto(): boolean {
    return TipoProduto_E_OperadoraComponent.isOdonto(this.tipoProduto);
  }
}
